<div *ngFor="let travel of travels" class="travel-row-wrapper">

  <div  class="travel-accordeon"  >
    <div class="chevron-expand" (click)="openItem(travel)">
      <span class="lnr lnr-chevron-right" [class.opened]="travel.isOpened"></span>
    </div>

    <div class="travel-item-image"
         [ngStyle]="{backgroundImage: 'url(' + travel?.image + ')'}"></div>

  <div class="travel-details-wrapper">
    <div class="travel-row-details-wrapper">
      <div class="travels-item-header"> Путешествие в {{travel.locationNames}}</div>
      <div class="travel-item-details">
        <div class="travels-item-dates">
          <span class="lnr lnr-calendar-full"></span>
          {{travel.dateFrom | momentDate}} -  {{travel.dateTo | momentDate}}
        </div>
        <div class="travels-item-people" *ngIf="travel.passengers?.length > 1 && travel.passengers?.length < 5">
          <span class="lnr lnr-users" ></span>
          {{travel.passengers?.length}}  человека
        </div>
        <div class="travels-item-people" *ngIf="travel.passengers?.length === 1 || travel.passengers?.length > 5">
          <span class="lnr lnr-users" ></span>
          {{travel.passengers?.length}}  человек
        </div>
      </div>

    </div>

  </div>

    <div *ngIf="travel.showPrice && (travel.fullInvoice.length > 0 || travel.partlyInvoice.length > 0)" class="travels-item-cost">
       {{travel.cost | cost:setInvoiceCurrency(travel.fullInvoice.length > 0 ? travel.fullInvoice[travel.fullInvoice.length - 1].type : travel?.partlyInvoice[travel?.partlyInvoice.length - 1].type, travel?.currency)}}
      <div class="partly-paid" *ngIf="travel.partlyInvoice.length > 0 && (travel?.status?.id === 7 || travel?.status?.id === 8 || travel?.status?.id === 3) && calculateFinalAmount(travel) > 0">
        Оплачено частично: {{calculateFinalAmount(travel) | cost:setInvoiceCurrency(travel.fullInvoice.length > 0 ? travel.fullInvoice[travel.fullInvoice.length - 1].type : travel?.partlyInvoice[travel?.partlyInvoice.length - 1].type, travel?.currency)}}
      </div>
    </div>

</div>

  <div *ngIf="travel.locations && travel.locations.length > 0"
          class="travel-expanded panel"
       [ngClass]="travel.isOpened ? 'opened' :'closed' ">

    <ng-container *ngFor="let location of travel?.locations; let i = index">
      <div class="travel-services">
        <span class="bullet"></span>
        <div>
          <div class="service-title">{{location.name}}</div>
          <div *ngFor="let service of location.services" class="service-item-wrapper">
            <div class="service-subtitle">
              {{service.service?.name}}: {{service?.details?.name}}
            </div>
<!--            <div class="service-description">-->
<!--              <span *ngIf="service?.service?.id !== 5">{{service?.comment}}</span>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </ng-container>

    <button (click)="openTravelProfile($event, travel)"
            class="show-more">Перейти в путешествие<span class="lnr lnr-chevron-right"></span>
    </button>
  </div>

</div>

<!--<table class="table travels-history-table noborder" *ngIf="isLoaded">-->

<!--  <tbody>-->

<!--  <tr class="tr-profile" *ngFor="let travel of travels" (click)="openTravelProfile($event, travel)">-->
<!--    <td class='max-screen mid-screen'>-->
<!--      {{travel.createdAt | momentDate}}-->
<!--    </td>-->

<!--    <td class='min-screen'>-->
<!--      <div class="status-min-screen">-->
<!--        <span [ngClass]=" 'ellipse-colored ' + 'ellipse-colored-'+ travel.status?.id?.toString()"></span>-->
<!--        <label class="label-min">{{travel.status?.text}}</label>-->
<!--      </div>-->
<!--      <div class="email-wrapper font-gray">Дата создания: {{travel.dateFrom | momentDate}}</div>-->
<!--      <div class="email-wrapper font-gray">Срок до: {{travel?.deadline | momentDate}}</div>-->
<!--      <div class="email-wrapper font-gray">Локации: {{travel.locationNames}}</div>-->
<!--      <div class="email-wrapper font-gray">Услуги: {{travel.serviceNames}}</div>-->
<!--      <div class="email-wrapper font-gray">Менеджер: {{travel?.manager?.name}}</div>-->
<!--      <div class="email-wrapper font-gray">{{ travel?.cost | cost:travel.currency}}</div>-->
<!--    </td>-->

<!--    <td class='max-screen mid-screen'>-->
<!--      <a uiSref="app.travel" [uiParams]="{id: travel.id}">{{travel.packageName}}</a>-->
<!--    </td>-->
<!--    <td class='max-screen mid-screen'>{{travel.dateFrom | momentDate}}<br>{{travel.dateTo | momentDate}}</td>-->
<!--    <td class='max-screen mid-screen'>{{travel.locationNames}}</td>-->
<!--    <td class='max-screen mid-screen'>{{travel.serviceNames}}</td>-->
<!--    <td class='max-screen mid-screen'>{{travel?.manager?.name}}</td>-->
<!--    <td class='max-screen mid-screen'>{{travel?.cost | cost:travel?.currency}}</td>-->

<!--    <td class='max-screen mid-screen travel-status-col'>-->
<!--      <span [ngClass]=" 'ellipse-colored ' + 'ellipse-colored-'+ travel?.status?.id?.toString()"></span>-->
<!--      <label class="label-min">{{travel?.status?.text}}</label>-->
<!--    </td>-->



<!--  </tr>-->
<!--  <tr *ngIf="!travels?.length">-->
<!--    <td colspan="50" class="no-list-data">Результатов не найдено</td>-->
<!--  </tr>-->
<!--  </tbody>-->

<!--</table>-->





<!--<div class="wrapper-pagination-footer">-->
<!--  <app-pagination [total]="total" [paging]="listFilters.paging" (notify)="onPageChange($event)"-->
<!--                  [style.visibility]="total > listFilters.paging.limit && isLoaded ? 'visible' : 'hidden'">-->
<!--  </app-pagination>-->
<!--</div>-->



